<template lang="pug">
  app-page(:fab-items="fabItems" title="База знаний" :searchValue="filter.searchText || ''" @search="text => (search = text.toLowerCase())")

    v-row(no-gutters)
      .col-3
        //app-toolbar(title="Раздел")
          
        //v-card 
          //v-treeview(v-if="knowledgeCategory.length>0" dense activatable open-all return-object item-key="id" item-text="title" :active.sync="selectedCategory" :items="knowledgeCategory")

        knowledge-explorer

      .col-9.pl-2
        knowledgebase-toolbar.mb-2
        .text-right
            v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>

        app-group-animation.mx-n1
          app-group-item.px-1(v-for="(doc,index) in knowledgeDocs" :key="doc.id" cols="12")
            knowledgebase-list(:doc="doc" @click.native="showDocument(doc)" :search="search")

        v-pagination(v-if="totalPages > 1" @input="setPage" v-model="filter.page" :total-visible="filter.perPage" :length="totalPages")
        

    dialog-manage-doc(v-model="dialog.manageDoc" ref="dialogManageDoc" @showDialogEditDoc="showEditDoc" @showDialogDelDoc="showDelDoc")
    dialog-new-doc(v-model="dialog.newDoc" ref="dialogNewDoc")
    dialog-edit-doc(v-model="dialog.editDoc" ref="dialogEditDoc")
    dialog-del-doc(v-model="dialog.delDoc" ref="dialogDelDoc")
    dialog-no-file-doc(v-model="dialog.noFileDoc" ref="dialogNoFileDoc")
    
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { userService } from "@/_services";

import knowledgeBaseToolbar from "./components/KnowledgeBaseToolbar";
import knowledgeBaseExplorer from "./components/KnowledgeBaseExplorer";
import dialogNewDoc from "./components/KnowledgeBaseDialogNewDoc";
import dialogEditDoc from "./components/KnowledgeBaseDialogEditDoc";
import dialogManageDoc from "./components/KnowledgeBaseDialogManageDoc";
import dialogDelDoc from "./components/KnowledgeBaseDialogDelDoc";
import dialogNoFileDoc from "./components/KnowledgeBaseDialogNoFileDoc";
import knowledgeList from "./components/KnowledgeBaseList";

import { config } from '@/_helpers'

export default {
  components: {
    dialogNewDoc,
    dialogEditDoc,
    dialogManageDoc,
    dialogDelDoc,
    dialogNoFileDoc,
    [knowledgeList.name]: knowledgeList,
    [knowledgeBaseToolbar.name]: knowledgeBaseToolbar,
    [knowledgeBaseExplorer.name]: knowledgeBaseExplorer
  },

  mounted() {
    this.$store.dispatch("knowledgeBase/init");
  },

  computed: {
    ...mapState("knowledgeBase", [
      "knowledgeCategory",
      "knowledgeDocs",
      "decreeStateList",
      "typeList",
      "filter",
      "totalPages"
    ]),
    ...mapGetters("knowledgeBase", [
      "gKnowledgeCategory",
      "gKnowledgeDocs",
      "gDecreeStateList",
      "gTypeList"
    ]),

    fabItems() {
      let fabItems = null;
      if (userService.existRole("ADMIN") || userService.existRole("KNOWLEDGE")) {
        fabItems = [
          {
            icon: "insert_drive_file",
            title: "Новый документ базы знаний",
            action: () => this.$refs.dialogNewDoc.show()
          }
        ];
      }
      return fabItems;
    }
  },

  methods: {
    ...mapActions("knowledgeBase", [
      "setCategory",
      "setFilter",
      "clearFilter",
      "setCategory",
      "setPage",
      "setSearchText"
    ]),

    showDocument(doc) {
      if (userService.existRole("ADMIN") || userService.existRole("KNOWLEDGE")) this.$refs.dialogManageDoc.show(doc);
      else if (doc.fileExt && doc.fileExt!='') this.loadFile(doc)
      else this.$refs.dialogNoFileDoc.show(doc);
    },

    showEditDoc(doc) {
      this.$refs.dialogEditDoc.show(doc);
    },

    loadFile(doc) {
        const link = document.createElement('a');
        link.href = config.apiUrl+'files/'+doc.fileExt;
        document.body.appendChild(link);
        link.click();
        link.remove();
    },

    showDelDoc(doc){
      this.$refs.dialogDelDoc.show(doc);
    }
  },

  watch: {
    /*selectedCategory: function(){
      this.setCategory(this.selectedCategory[0] || null)
    }*/
    search: function() {
      this.setSearchText(this.search);
    }
  },

  data() {
    return {
      //selectedCategory:[],
      dialog: {
        newDoc: false,
        editDoc: false,
        manageDoc: false,
        delDoc: false,
        noFileDoc: false
      },
      search: null
    };
  }
};
</script>